export default __webpack_public_path__ + "static/media/personal_affairs_organizer.125b3bf8.pdf";